import { render } from "./SendVerifyCodeBtn.vue?vue&type=template&id=1bec2ad1&lang=pug"
import script from "./SendVerifyCodeBtn.vue?vue&type=script&lang=js"
export * from "./SendVerifyCodeBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__